"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegTwit = void 0;
const base_1 = require("./base");
const twit_1 = require("../services/twit");
/**
 * Twitter Pixel
 */
class AnIntegTwit extends base_1.AnIntegBase {
    static isLoaded() {
        return twit_1.AnServTwit.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        twit_1.AnServTwit.sendInit(this.getPixelId(siteCategory), null, null, null);
        return true;
    }
    static sendPage(siteCategory, userId, email) {
        twit_1.AnServTwit.sendPage(this.getPixelId(siteCategory));
        return true;
    }
}
exports.AnIntegTwit = AnIntegTwit;
AnIntegTwit.shouldSendEveryPage = true;
AnIntegTwit.pixelId = {
    prod: {
        defaultId: "nvjfi",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "nvjfi",
        ecomm: null,
        club: null,
    },
};
